import React from "react";
import styled from "styled-components";
import NavEntry from "./NavEntry";
import  {entriesHomePage} from "./navigationConfig";
import {useLocation} from "react-router-dom";
import {useQuery} from "react-query";
import {userDetails} from "../../../utils/const/query-key";
import apiService from "../../../api/apiService";
import {canViewDemoPoint} from "../../../utils/rolePermissions";

const Container = styled.nav`
  grid-area: sidenav;
  background-color: var(--color-sidebar-main);
  font-size: 1.4rem;
  border: solid var(--color-border-general);
  border-width: 0 1px;
  user-select: none;
`;

const createNavigationElementFromEntry = (entry, key) => {
  const { title, target, icon } = entry;
  return <NavEntry title={title} target={target} icon={icon} key={key} />;
};



const Sidebar = () => {
  const {data: userData, isLoading} = useQuery(userDetails, () => apiService.getUser(), {
    staleTime: Infinity,
    initialData: {}
  });

  let location = useLocation();

const sideBarEntries = () => {
  if (location.pathname.includes("admin") && userData?.isAdmin  && !isLoading) {
    return [...entriesHomePage["admin"]];
  }
  else if(location.pathname.includes("admin") && userData?.isTechPointAdminReports && !isLoading){
    return [...entriesHomePage["reportsAdmin"]];
  }
  else if (location.pathname === "/demo-point" && !canViewDemoPoint(userData)) {
    return [];
  }
  return entriesHomePage["home"].filter((entry) => entry.canView(userData));
}


  const navEntries = sideBarEntries();
  return <Container>
    {navEntries.map((entry, index) => createNavigationElementFromEntry(entry, index))}
  </Container>;
};

export default Sidebar;
